module.exports = __webpack_public_path__ + "assets/images/amira_default.8c5d129148c6bd5bb213b6ad9cfac6b7.svg";